import {
  SHARED_FORGOT_UPDATE_PASSWORD_FAIL,
  SHARED_FORGOT_UPDATE_PASSWORD_REQUEST,
  SHARED_FORGOT_UPDATE_PASSWORD_SUCCESS,
  SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_FAIL,
  SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_REQUEST,
  SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS,
  SHARED_LOGIN_FAIL,
  SHARED_LOGIN_REQUEST,
  SHARED_LOGIN_SUCCESS,
  SHARED_LOGOUT,
  SHARED_ADD_ANNOUNCEMENT_FAIL,
  SHARED_ADD_ANNOUNCEMENT_REQUEST,
  SHARED_ADD_ANNOUNCEMENT_SUCCESS,
  SHARED_DELETE_ANNOUNCEMENT_FAIL,
  SHARED_DELETE_ANNOUNCEMENT_REQUEST,
  SHARED_DELETE_ANNOUNCEMENT_SUCCESS,
  SHARED_GET_ANNOUNCEMENT_FAIL,
  SHARED_GET_ANNOUNCEMENT_REQUEST,
  SHARED_GET_ANNOUNCEMENT_SUCCESS,
} from "../../types/shared/authTypes";

export const sendOtpForgetPasswordReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        sendOtpForgetPasswordInfo: payload,
        error: "",
      };
    case SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        sendOtpForgetPasswordInfo: {},
      };
    default:
      return state;
  }
};

export const updatePasswordReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHARED_FORGOT_UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SHARED_FORGOT_UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        updatePasswordInfo: payload,
        error: "",
      };
    case SHARED_FORGOT_UPDATE_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        updatePasswordInfo: null,
        error: payload,
      };
    default:
      return state;
  }
};

export const sharedLoginReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHARED_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SHARED_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        sharedUserInfo: payload,
        error: "",
      };
    case SHARED_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        sharedUserInfo: {},
      };
    case SHARED_LOGOUT:
      return {
        sharedUserInfo: null,
      };
    default:
      return state;
  }
};

export const addAnnouncementReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHARED_ADD_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        addAnnounceLoading: true,
      };
    case SHARED_ADD_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        addAnnounceLoading: false,
        addAnnounceInfo: payload,
        addAnnounceError: "",
      };
    case SHARED_ADD_ANNOUNCEMENT_FAIL:
      return {
        ...state,
        addAnnounceLoading: false,
        addAnnounceInfo: null,
        addAnnounceError: payload,
      };
    default:
      return state;
  }
};

export const deleteAnnouncementReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHARED_DELETE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        deleteAnnounceLoading: true,
      };
    case SHARED_DELETE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        deleteAnnounceLoading: false,
        deleteAnnounceInfo: payload,
        deleteAnnounceError: "",
      };
    case SHARED_DELETE_ANNOUNCEMENT_FAIL:
      return {
        ...state,
        deleteAnnounceLoading: false,
        deleteAnnounceInfo: null,
        deleteAnnounceError: payload,
      };
    default:
      return state;
  }
};

export const getAnnouncementReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHARED_GET_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        getAnnounceLoading: true,
      };
    case SHARED_GET_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        getAnnounceLoading: false,
        getAnnounceInfo: payload,
        getAnnounceError: "",
      };
    case SHARED_GET_ANNOUNCEMENT_FAIL:
      return {
        ...state,
        getAnnounceLoading: false,
        getAnnounceInfo: [],
        getAnnounceError: payload,
      };
    default:
      return state;
  }
};